<template>
  <section id="team" class="bg-gray pt-3">
    <div class="container">
      <div class="section-header text-center">
        <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">فهرست پایان نامه های کارشناسی ارشد </h2>
        <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-12 col-md-12 col-xs-12  text-right p-5 bg-white position-relative mrGradient ">
          <h5><strong>ردیف /  نام دانشجو  /  عنوان پایان نامه ...   /  نام استاد راهنما (مشاور)  /  تاریخ دفاع</strong></h5>
          <hr class="bg-green">
          <ul>
            <li v-for="(master , id) in masters.slice(0,countListMaster)" :key="id"><strong>{{ id + 1 }} </strong><i
                class="lni lni-chevron-left"></i>{{ master.title }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
import {mastersThesis} from "@/Data/thesisData";

export default {
  name: "MasterThesis",
  data() {
    return {
      countList: this.$route.params.countList,
      masters: mastersThesis,
    }
  },
  computed: {
    countListMaster() {
      return this.$route.params.countList > 0 ? this.$route.params.countList  : 25;
    },
  },
}
</script>

<style scoped>
ul li i {
  font-weight: bolder;
  margin-left: 10px;
  font-size: .8rem;
}
.mrGradient{
  border-radius: 2rem;
}
.mrGradient::before {
  position: absolute;
  content: '';
  bottom:0;
  right: 0;
  /*background: rgb(255,255,255);*/
  background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.7399159492898721) 100%);
  width: inherit;
  height: 75px;
  border-radius: 0 0 2rem 2rem;
}
</style>